import {
  ServiceSummaryVariantIconColor,
  ITotalsServiceSummary,
  SERVICE_SUMMARY_VARIANTS
} from 'components/SummaryBanner/SummaryBanner.types';
import TotalsInServiceSummary from '../TotalsInServiceSummary/TotalsInServiceSummary';
import QuoteStatusInServiceSummary from '../QuoteStatusInServiceSummary/QuoteStatusInServiceSummary';
import { BordOneToneIcon } from 'components/NudosComponents';
import { CURRENCIES } from 'types/bussines';
import './RejectedQuote.scss';

interface IRejectedQuoteProps {
  quoteLink?: string;
  totals?: ITotalsServiceSummary;
  isManualQuote?: boolean;
}

const RejectedQuote = ({
  totals = { totalUSD: 0, total: 0, currency: CURRENCIES.USD },
  ...rest
}: IRejectedQuoteProps) => {
  return (
    <div className="serviceSummaryBanner rejectedQuote">
      <TotalsInServiceSummary totals={totals} />
      <QuoteStatusInServiceSummary
        variant="rejected"
        icon={
          <BordOneToneIcon
            variant="x"
            customWidth="10px"
            stroke={ServiceSummaryVariantIconColor[SERVICE_SUMMARY_VARIANTS.REJECTED]}
          />
        }
        {...rest}
      />
    </div>
  );
};

export default RejectedQuote;
